import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import AspiringLayout from "@/components/AspiringLayout";
import { AssessmentTab } from "@/components/aspiring-tabs/AssessmentTab";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function AssessmentContent({ user }) {
  const [loading, setLoading] = useState(true);
  const [clearing, setClearing] = useState(false);
  const [profile, setProfile] = useState({});

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/aspiring/profile`, { credentials: "include" })
      .then(r => r.ok ? r.json() : {})
      .then(d => setProfile(d.profile || {}))
      .finally(() => setLoading(false));
  }, []);

  const clear = async () => {
    if (!confirm("Are you sure you want to clear your assessment?")) return;
    setClearing(true);
    const clearedProfile = { ...profile, assessment: null };
    setProfile(clearedProfile);
    try {
      await fetch(`${BACKEND_URL}/api/aspiring/profile`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(clearedProfile)
      });
      toast.success("Assessment cleared");
    } catch {
      toast.error("Failed to clear");
    }
    setClearing(false);
  };

  const update = async (k, v) => {
    setProfile(p => ({ ...p, [k]: v }));
    if (k === "assessment") {
      try {
        await fetch(`${BACKEND_URL}/api/aspiring/profile`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ ...profile, [k]: v })
        });
      } catch (error) {
        console.error("Failed to update profile:", error);
      }
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="aspiring-assessment-page">
      <AssessmentTab profile={profile} update={update} />
      {profile.assessment && (
        <Button 
          onClick={clear} 
          disabled={clearing} 
          variant="outline"
          className="w-full border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
          data-testid="clear-assessment-btn"
        >
          {clearing && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
          <Trash2 className="w-4 h-4 mr-2" />
          Clear Assessment
        </Button>
      )}
    </div>
  );
}

export default function AspiringAssessmentPage() {
  return <AspiringLayout>{({ user }) => <AssessmentContent user={user} />}</AspiringLayout>;
}
